import { Splitter } from 'antd';
import { useLocation } from 'react-router-dom';
import { isNumber } from '@/scripts/utils';
import { ContactsProvider } from '@/contexts/contacts';
import { useSessionContext } from '@/contexts/session/context';
import { requestNotificationPermission } from '@/configs/firebase/config';
import { ChatProvider } from '../../contexts/chat';
import AppNav from './components/sider';
import MediaCall from './components/mediaCall';
import styles from './index.module.scss';
import { SplitterData } from './type';
import ProfileCenter from './components/profileCenter';

const Main = () => {
  const { session } = useSessionContext();
  const lcoation = useLocation();
  const params = useParams();
  const outlet = useOutlet();
  const [siderSize, setSiderSize] = useState<string | number>(
    SplitterData.LEFT_DEFAULT_SIZE
  );
  const [curnNavKey, setCurNavKey] = useState<string>();
  const [cacheNavComs, setCacheNavComs] = useState<Record<string, any>>({});

  const collapse = useMemo(() => {
    return isNumber(siderSize) ? (siderSize as number) <= SplitterData.LEFT_MIN : false;
  }, [siderSize]);

  useLayoutEffect(() => {
    const cachePath = location.pathname
      .split('/')
      .filter((i) => i && i !== params.type)
      .join('/');

    if (cachePath) {
      setCurNavKey(cachePath);
      if (!cacheNavComs[cachePath]) {
        cacheNavComs[cachePath] = outlet;
        setCacheNavComs({ ...cacheNavComs });
      }
    }
  }, [lcoation.pathname, params.type, cacheNavComs, outlet]);

  useEffect(() => {
    if (session?.user) {
      requestNotificationPermission();
    }
  }, [session?.user]);

  if (!session?.user) {
    return null;
  }

  return (
    <ChatProvider>
      <ContactsProvider>
        <div className={styles.main}>
          <Splitter
            onResize={(widths) => {
              if (widths[0] <= SplitterData.LEFT_THESHOLD) {
                setSiderSize(SplitterData.LEFT_MIN);
              } else {
                setSiderSize(widths[0]);
              }
            }}
          >
            <Splitter.Panel
              className={cls(styles.left, 'scrollbar_hover')}
              style={{
                minWidth: siderSize,
                maxWidth: siderSize,
              }}
              size={siderSize}
              min={SplitterData.LEFT_MIN}
              max={SplitterData.LEFT_MAX}
            >
              <AppNav collapse={collapse} />
            </Splitter.Panel>
            <Splitter.Panel>
              {Object.keys(cacheNavComs)?.map((key) => {
                return (
                  <div
                    className={styles.container}
                    key={key}
                    hidden={key !== curnNavKey}
                  >
                    {cacheNavComs[key]}
                  </div>
                );
              })}
            </Splitter.Panel>
          </Splitter>
        </div>
        <MediaCall />
        <ProfileCenter />
      </ContactsProvider>
    </ChatProvider>
  );
};
export default Main;
